import React from "react";
import { FilePdfOutlined, CloudDownloadOutlined, RollbackOutlined } from "@ant-design/icons";
import TableRowActions from "../../ui/TableRowActions/TableRowActions";
import { formatAmount } from "./utils";

// Wraps an icon + text into the standard dropdown menu-item label used across
// the app's TableRowActions menus.
const menuLabel = (icon, text) => (
   <span className="table-row-actions__menu-item icon-group">
      {icon}
      {text}
   </span>
);

const STATUS_LABELS = {
   refundinprocess: "Refund in process"
};

const StatusCell = ({ status }) => {
   const variant = String(status).toLowerCase();
   const label = STATUS_LABELS[variant] ?? status;
   return (
      <span className={`funds__status funds__status--${variant}`}>
         <span className="funds__status-dot" />
         {label}
      </span>
   );
};

// Builds the PurchaseHistory table columns. Kept as a factory (rather than a
// static array) so the per-row download handler is injected from the owner.
export const getPurchaseHistoryColumns = ({ onDownloadItem, onRefundItem }) => [
   {
      title: "File name",
      dataIndex: "fileName",
      key: "fileName",
      width: 280,
      render: (text) => (
         <div className="funds__file-name">
            <FilePdfOutlined className="funds__file-icon" />
            <span>{text}</span>
         </div>
      )
   },
   {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 160
   },
   {
      title: "Balance added",
      // Backend transaction field is `credits`; keep the dataIndex/key literal.
      dataIndex: "credits",
      key: "credits",
      width: 160,
      render: (value) => formatAmount(value)
   },
   // {
   //    title: "Amount paid",
   //    dataIndex: "amountPaid",
   //    key: "amountPaid",
   //    width: 160
   // },
   {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 190,
      render: (status) => <StatusCell status={status} />
   },
   {
      key: "actions",
      fixed: "right",
      width: 70,
      render: (_text, record) => {
         const isSuccess = String(record.status).toLowerCase() === "success";
         // if (!isSuccess) return null;

         const isRefunded = String(record.status).toLowerCase() === "refunded";
         const isExpense = String(record.type).toLowerCase() === "expense";
         const menuItems = [
            record.invoiceUrl && {
               key: "download",
               label: menuLabel(<CloudDownloadOutlined />, "Download"),
               onClick: () => onDownloadItem?.(record)
            },
            !isRefunded &&
               !isExpense &&
               isSuccess && {
                  key: "refund",
                  label: menuLabel(<RollbackOutlined />, "Refund"),
                  onClick: () => onRefundItem?.(record)
               }
         ].filter(Boolean);

         return <TableRowActions menuItems={menuItems} />;
      }
   }
];
